<template>
	<router-link
		v-if="featureAvailable('downloadFixtures')"
		class="top-nav-link visible-desktop"
		:to="{ name: 'download-fixtures' }"
	>
		<svg
			viewBox="0 0 13 13"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			class="top-nav-link__icon"
		>
			<path
				d="M10.9818 5C11.2865 5 11.5443 5.11719 11.7787 5.32812C11.9896 5.5625 12.1068 5.82031 12.1068 6.125V9.21875C12.1068 9.3125 12.0599 9.38281 12.013 9.42969C11.9662 9.47656 11.8959 9.5 11.8255 9.5H10.6068V11.9375C10.6068 12.1016 10.5365 12.2422 10.4427 12.3359C10.3255 12.4531 10.1849 12.5 10.0443 12.5H2.1693C2.00523 12.5 1.86461 12.4531 1.77086 12.3359C1.65367 12.2422 1.6068 12.1016 1.6068 11.9375V9.5H0.388046C0.294296 9.5 0.223984 9.47656 0.177109 9.42969C0.130234 9.38281 0.106796 9.3125 0.106796 9.21875V6.125C0.106796 5.82031 0.200546 5.5625 0.434921 5.32812C0.645859 5.11719 0.903671 5 1.2318 5H1.6068V1.0625C1.6068 0.921875 1.65367 0.78125 1.77086 0.664062C1.86461 0.570312 2.00523 0.5 2.1693 0.5H8.68492C8.82555 0.5 8.96617 0.570312 9.08336 0.664062L10.4427 2.02344C10.5365 2.14062 10.6068 2.28125 10.6068 2.42188V5H10.9818ZM9.1068 11V8.75H3.1068V11H9.1068ZM3.1068 5.75H9.1068V3.5H8.1693C8.00523 3.5 7.86461 3.45312 7.77086 3.33594C7.65367 3.24219 7.6068 3.10156 7.6068 2.9375V2H3.1068V5.75ZM10.2318 7.4375C10.3724 7.4375 10.513 7.39062 10.6302 7.27344C10.724 7.17969 10.7943 7.03906 10.7943 6.875C10.7943 6.73438 10.724 6.59375 10.6302 6.47656C10.513 6.38281 10.3724 6.3125 10.2318 6.3125C10.0677 6.3125 9.92711 6.38281 9.83336 6.47656C9.71617 6.59375 9.6693 6.73438 9.6693 6.875C9.6693 7.03906 9.71617 7.17969 9.83336 7.27344C9.92711 7.39062 10.0677 7.4375 10.2318 7.4375Z"
			/>
		</svg>
		
		<span class="top-nav-link__text">{{ $t("nav.print-matches") }}</span>
	</router-link>
</template>

<script>
export default {
	name: "DownloadFixtureLink",
};
</script>

<style lang="scss">
.top-nav-link {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 10px 15px;
	text-decoration: none;
	&__icon {
		margin-right: 5px;
		width: 15px;
		path {
			fill: var(--black);
		}
	}
	&__text {
		white-space: nowrap;
		color: var(--black);
		font-size: var(--font-medium);
		font-weight: var(--font-weight-lighter);
	}
}
</style>
